import { pathOr } from 'ramda';
import { COMPONENTS_MAP } from './contentManager.constants';

export const getComponentName = pathOr('Unknown', ['sys', 'contentType', 'sys', 'id']);

export const getDisplayComponent = component => {
  const componentType = getComponentName(component);
  return COMPONENTS_MAP[componentType];
};
